import { get, post, put, remove } from '../axios';

const API_PREFIX = '/shopAdmin';

export default {
  /**
   * Get all packages
   */
  getPakete() {
    const URL = `${API_PREFIX}/pakete`;

    return get(URL);
  },

  /**
   * get all vertragsgenerator-pakete
   * @returns
   */
  getVertragsgeneratorPakete() {
    const URL = `${API_PREFIX}/vertragsgenerator/pakete`;

    return get(URL);
  },

  /**
   * get Mandanten mit aufgaben
   */
  fetchMandanten() {
    const URL = `${API_PREFIX}/mandant/liste`;

    return get(URL);
  },

  /**
   * get all clients
   */
  fetchClients() {
    const URL = `${API_PREFIX}/client`;

    return get(URL);
  },

  fetchMandantPakete(clientId) {
    const URL = `${API_PREFIX}/mandant/${clientId}/vertragsgenerator/pakete`;

    return get(URL);
  },

  updateMandantPakete(clientId, body) {
    const URL = `${API_PREFIX}/mandant/${clientId}/vertragsgenerator/pakete`;

    return put(URL, body);
  },

  /**
   * post vertragsgenerator pakete des aufgabenBearbeiters
   *
   * @param {string} aufgabeBearbeiterId
   * @param {string} body mit Pakete als Array mit paketIds
   */
  postVertragsgeneratorPakete(aufgabeBearbeiterId, body) {
    const URL = `${API_PREFIX}/vertragsgenerator/pakete/${aufgabeBearbeiterId}`;

    return put(URL, body);
  },

  /**
   * get MandantenDaten
   *
   * @param {string} aufgabenBearbeiterId
   */
  getMandantenDaten(aufgabenBearbeiterId) {
    const URL = `${API_PREFIX}/mandant/${aufgabenBearbeiterId}`;

    return get(URL);
  },

  /**
   * get MandantenDaten
   *
   * @param {string} clientId
   */
  fetchUnternehmensDaten(clientId) {
    const URL = `${API_PREFIX}/mandant/${clientId}/unternehmensdaten`;

    return get(URL);
  },

  /**
   * get sparten
   */
  getSparten() {
    const URL = `${API_PREFIX}/sparten`;

    return get(URL);
  },

  /**
   * Create new package
   *
   * @param {Object} body
   */
  postPaket(body) {
    const URL = `${API_PREFIX}/pakete/create`;

    return post(URL, body);
  },

  /**
   * Update package
   *
   * @param {Object} body
   * @param {String} id
   */
  putPaket(body, id) {
    const URL = `${API_PREFIX}/pakete/${id}`;

    return put(URL, body);
  },

  /**
   * Delete package
   *
   * @param {String} id
   */
  deletePaket(id) {
    const URL = `${API_PREFIX}/pakete/${id}`;

    return remove(URL);
  },

  /**
   * Get all not assigned packages
   *
   * @param {String} paketId
   */
  getPaketeNotAssigned(paketId) {
    const URL = `${API_PREFIX}/pakete/${paketId}/notAssigned`;

    return get(URL);
  },

  /**
   * Get all not assigned contracts
   */
  getVertraegeNotAssigned() {
    const URL = `${API_PREFIX}/vertraege/notAssigned`;

    return get(URL);
  },

  /**
   * Add package to package
   *
   * @param {String} wrappedPaketId
   * @param {String} addedPaketId
   */
  addPaketToPaket(wrappedPaketId, addedPaketId) {
    const URL = `${API_PREFIX}/pakete/${wrappedPaketId}/addPaket/${addedPaketId}`;

    return post(URL);
  },

  /**
   * Add contract to package
   *
   * @param {String} wrappedPaketId
   * @param {String} addedVertragId
   */
  addVertragToPaket(wrappedPaketId, addedVertragId) {
    const URL = `${API_PREFIX}/pakete/${wrappedPaketId}/addVertrag/${addedVertragId}`;

    return post(URL);
  },

  /**
   * set sparte of package
   *
   * @param {string} paketId
   * @param {string} sparteId
   */
  setSparte(paketId, sparteId) {
    const URL = `${API_PREFIX}/setSparte/${paketId}/${sparteId}`;

    return post(URL);
  },
  /**
   * get clientVertragAboPreis
   *
   * @param {string} clientId
   * @param {string} paketId
   * @param {string} vertragsId
   */
  fetchClientVertragAboPreis(clientId, paketId, vertragsId) {
    const URL = `${API_PREFIX}/clientVertragAboPreis/${clientId}/${paketId}/${vertragsId}`;

    return get(URL);
  },

  /**
   * put clientVertragAboPreis
   *
   * @param {string} clientId
   * @param {string} paketId
   * @param {string} vertragsId
   * @param {object} body // { "aboPreis": <number> }
   */
  setOrUpdateClientVertragAboPreis(clientId, paketId, vertragsId, body) {
    const URL = `${API_PREFIX}/clientVertragAboPreis/${clientId}/${paketId}/${vertragsId}`;

    return put(URL, body);
  },

  /**
   * get clientPaketInitialPreis
   *
   * @param {string} clientId
   * @param {string} paketId
   */
  fetchClientPaketInitialPreis(clientId, paketId) {
    const URL = `${API_PREFIX}/clientPaketInitialPreis/${clientId}/${paketId}`;

    return get(URL);
  },

  /**
   * put clientPaketInitialPreis
   *
   * @param {string} clientId
   * @param {string} paketId
   * @param {object} body // { "initialPreis": <number> }
   */
  setOrUpdateClientPaketInitialPreis(clientId, paketId, body) {
    const URL = `${API_PREFIX}/clientPaketInitialPreis/${clientId}/${paketId}`;

    return put(URL, body);
  },

  /**
   * Receive packages that include a contract
   *
   * @param {string} vertragsId
   */
  fetchPaketeByVertrag(vertragsId) {
    const URL = `${API_PREFIX}/paketeByVertrag/${vertragsId}`;

    return get(URL);
  },

  /**
   * get clientPaketAboPreis
   *
   * @param {string} paketId
   * @param {string} vertragsId
   */
  fetchPaketVertragAboPreis(paketId, vertragsId) {
    const URL = `${API_PREFIX}/paketVertragAboPreis/${paketId}/${vertragsId}`;

    return get(URL);
  },

  /**
   * put clientPaketAboPreis
   *
   * @param {string} paketId
   * @param {string} vertragsId
   * @param {object} body // { kleinst: ..., klein: ..., mittel: ..., groß: ..., sehrGroß: ... }
   */
  putPaketVertragAboPreis(paketId, vertragsId, body) {
    const URL = `${API_PREFIX}/paketVertragAboPreis/${paketId}/${vertragsId}`;

    return put(URL, body);
  },

  /**
   * get VertragsDetails by vertragsId
   *
   * @param {string} vertragsId
   */
  fetchVertragsDetails(vertragsId) {
    const URL = `${API_PREFIX}/vertragDetailsByVertragId/${vertragsId}`;

    return get(URL);
  },

  /**
   * get Rechungen
   *
   * @param {string} zeitraum // YYYYY-MM
   * @param {string} versendet // versendet/offen
   */
  fetchRechnungen(zeitraum, versendet) {
    const URL = `${API_PREFIX}/rechnungen/${zeitraum}/${versendet}`;

    return get(URL);
  },

  /**
   * put Rechnung-Notiz
   *
   * @param {string} clientId
   * @param {object} body
   */
  putRechnungNotiz(clientId, body) {
    const URL = `${API_PREFIX}/rechnung/notizen/${clientId}`;

    return put(URL, body);
  },

  /**
   * send Rechnung
   *
   * @param {string} clientId
   * @param {string} zeitraum // YYYYY-MM
   */
  sendRechnung(clientId, zeitraum) {
    const URL = `${API_PREFIX}/rechnung/${clientId}/${zeitraum}/senden`;

    return post(URL);
  },

  /**
   * get RechnungsPositionen
   *
   * @param {string} clientId
   * @param {string} zeitraum // YYYYY-MM
   */
  fetchRechnungsPositionen(clientId, zeitraum) {
    const URL = `${API_PREFIX}/rechnungsPositionen/${clientId}/${zeitraum}`;

    return get(URL);
  },

  /**
   * put RechnungsPositionen
   *
   * @param {string} clientId
   * @param {string} zeitraum // YYYYY-MM
   * @param {object} body // RechnungsPosition
   */
  putRechnungsPositionen(clientId, zeitraum, body) {
    const URL = `${API_PREFIX}/rechnungsPosition/${clientId}/${zeitraum}`;

    return put(URL, body);
  },

  /**
   * delete RechnungsPositionen
   *
   * @param {string} rechnungsPositionId
   */
  deleteRechnungsPosition(rechnungsPositionId) {
    const URL = `${API_PREFIX}/rechnungsPosition/${rechnungsPositionId}`;

    return remove(URL);
  },

  /**
   * get all Kostenstellen
   *
   * @returns
   */
  getKostenstellen() {
    const URL = `${API_PREFIX}/kostenstellen`;

    return get(URL);
  },
};
